import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
// Iconos relevantes para los servicios ofrecidos (actualizados)
import {
  FiTrendingUp, // Para SEO (tendencia ascendente)
  FiMessageSquare, // Para Redes Sociales (comunicación, comunidad)
  FiCode, // Para Desarrollo de Software (código)
  FiUser, // Para Marca Personal (individuo)
  FiChevronUp // Para el botón de volver arriba
} from "react-icons/fi";
import ScrollToTop from 'react-scroll-up';
import Header from "../component/header/Header"; // Asumiendo traducido o configuración externa
import Footer from "../component/footer/Footer"; // Asumiendo traducido o configuración externa

// Lista de Servicios actualizada y traducida
const ServiceList = [
  {
    icon: <FiTrendingUp />,
    title: 'Posicionamiento Web (SEO)',
    // Placeholder - REEMPLAZAR con descripción detallada del servicio SEO
    description: 'Aumenta tu visibilidad en buscadores como Google y atrae tráfico orgánico cualificado interesado en tus productos o servicios.'
  },
  {
    icon: <FiMessageSquare />,
    title: 'Gestión de Redes Sociales',
     // Placeholder - REEMPLAZAR con descripción detallada del servicio de Social Media
    description: 'Creamos y gestionamos tu presencia en redes sociales, conectando con tu audiencia, construyendo comunidad y potenciando tu marca.'
  },
  {
    icon: <FiCode />,
    title: 'Desarrollo de Software a Medida',
     // Placeholder - REEMPLAZAR con descripción detallada del servicio de Desarrollo
    description: 'Diseñamos y construimos soluciones tecnológicas (web, apps) personalizadas que impulsan la eficiencia y el crecimiento de tu negocio.'
  },
  {
    icon: <FiUser />,
    title: 'Desarrollo de Marca Personal',
    // Placeholder - REEMPLAZAR con descripción detallada del servicio de Marca Personal
    description: 'Te ayudamos a definir, construir y proyectar una marca personal sólida y coherente para destacar en tu sector profesional.'
  },
  // Puedes añadir más servicios si es necesario, manteniendo la estructura.
  // Por ejemplo:
  // {
  //   icon: <FiPenTool />, // Icono para diseño gráfico o branding general
  //   title: 'Diseño Gráfico y Branding',
  //   description: 'Creamos la identidad visual de tu marca, desde el logo hasta materiales de marketing impactantes.'
  // },
]

class Service extends Component {
  render() {
    return (
      <React.Fragment>
        {/* Título de la pestaña del navegador */}
        <PageHelmet pageTitle='Servicios' />
        {/* Cabecera */}
        <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

        {/* Inicio Área Breadcrumb */}
        <Breadcrumb title={'Servicios'} />
        {/* Fin Área Breadcrumb */}

        {/* Inicio Área de Servicios Principal */}
        <div className="service-area ptb--120 bg_color--1"> {/* Cambiado bg_color a 1 para consistencia si es necesario */}
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center mb--30">
                  {/* Título principal de la sección */}
                  <h2>Nuestros Servicios</h2>
                   {/* Descripción general (Placeholder - REEMPLAZAR) */}
                  <p>Ofrecemos soluciones digitales integrales diseñadas para potenciar <br /> tu presencia online y ayudarte a alcanzar tus objetivos.</p>
                </div>
              </div>
            </div>
            {/* Renderizado de la lista de servicios */}
            <div className="row service-one-wrapper">
              {ServiceList.map((val, i) => (
                // Ajusta las clases de columna si tienes un número diferente de servicios (ej. col-lg-3 si tienes 4)
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                   {/* Enlace a página de detalle del servicio (REEMPLAZAR href con links específicos si existen) */}
                  <a > {/* Idealmente: href={`/servicios/${val.title.toLowerCase().replace(/\s+/g, '-')}`} */}
                    <div className="service service__style--2">
                      <div className="icon">
                        {val.icon}
                      </div>
                      <div className="content">
                        <h3 className="title">{val.title}</h3>
                        <p>{val.description}</p>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Fin Área de Servicios Principal */}

        {/* Se eliminaron las otras secciones repetitivas ("Strategy", "Development", etc.) */}
        {/* Si necesitas agrupar servicios de forma diferente, puedes crear secciones distintas con listas filtradas o separadas. */}

        {/* Inicio Botón Volver Arriba */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* Fin Botón Volver Arriba */}

        {/* Pie de página */}
        <Footer />
      </React.Fragment>
    )
  }
}
export default Service;